// extracted by mini-css-extract-plugin
module.exports = {"LoanForm":"LoanCalculator_LoanForm__1rcm0","Btn":"LoanCalculator_Btn__wi9N3","Error":"LoanCalculator_Error__16IMI"};